
<template>
  <span>
    <v-list dense>


            <v-list-item
                @click="$emit('selected')"
                v-for="record in result.items"
                :key="record.id"
                color="blue"
                class="mb-2 text-decoration-none rounded-lg"
                :to="`/wallet/transaction/${record.uuid}`"
            >

        <v-list-item-avatar size="50" rounded="lg" color="blue lighten-5">
            <v-icon color="blue">mdi-bank-outline</v-icon>
          </v-list-item-avatar>
        <v-list-item-content>

          <v-list-item-title>
             {{ record.description }}
          </v-list-item-title>
          <v-list-item-subtitle>Amount: {{ record.amount | toMoney | currency_symbol }}</v-list-item-subtitle>
          <v-list-item-subtitle>Date: {{ record.created_at | humanDateTime }}</v-list-item-subtitle>
          <v-list-item-subtitle>Channel: {{ record.channel.replaceAll("_"," ") }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action-text>
             <v-chip
                 class="text-danger font-weight-bolder red lighten-5"
                 small
                 v-if="record.type.toLowerCase() == 'debit'"
             >
              {{ record.type }}
            </v-chip>

            <v-chip
                class="text-success font-weight-bolder green lighten-5"
                small
                v-if="record.type.toLowerCase() == 'credit'"
            >
              {{ record.type }}
            </v-chip>
          <v-icon color="grey lighten-2" small>mdi-chevron-right</v-icon>

        </v-list-item-action-text>

      </v-list-item>

    </v-list>
  </span>
</template>
<script>
export default {
  props: ["result"],
  name: "WalletTransactions"
}
</script>


<style scoped>

</style>